<template>
  <div id="adminClient">
    <vue-headful :title="$store.state.option['conta_pessoal_driver-titulo-' + lang]" :lang="lang" />

    <div class="panel margin-bottom-15" >
      <div class="panel-heading">
        <h3 class="panel-title">{{$store.state.option['filters-' + lang]}}</h3>
      </div>
      <div class="panel-body container-fluid">
        <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                  <input type="text" class="form-control" :placeholder="$store.state.option['conta_pessoal_reserved-Reservation-' + lang]" v-model="form.Reservation" />
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                  <select class="form-control" v-model="form.PickupStation">
                    <option value="" selected>{{$store.state.option['conta_pessoal_reserved-PickupStation-' + lang]}}</option>
                    <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
                  </select>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                  <select class="form-control" v-model="form.StatusDescription">
                    <option value="" selected>{{$store.state.option['conta_pessoal_reserved-StatusDescription-' + lang]}}</option>
                    <option value="Archived">{{ $store.state.option['estado-Archived-' + lang] }}</option>
                    <option value="Waiting confirmation">{{ $store.state.option['estado-waiting_confirmation-' + lang] }}</option>
                    <option value="Confirmed">{{ $store.state.option['estado-Confirmed-' + lang] }}</option>
                    <option value="Not confirmed">{{ $store.state.option['estado-not_confirmed-' + lang] }}</option>
                    <option value="Cancelled by the customer">{{ $store.state.option['estado-Cancelled by the customer-' + lang] }}</option>
                    <option value="In analysis">{{ $store.state.option['estado-under_analysis-' + lang] }}</option>
                    <option value="NoShow">{{ $store.state.option['estado-NoShow-' + lang] }}</option>
                    <option value="Processed">{{ $store.state.option['estado-Processed-' + lang] }}</option>
                    <option value="Turn-down">{{ $store.state.option['estado-turn_down-' + lang] }}</option>
                  </select>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                <div>
                  <date-picker v-model="form.PickupDate" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :placeholder="$store.state.option['conta_pessoal_reserved-PickupDate-' + lang]"></date-picker>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                  <select class="form-control" v-model="form.DropOffStation">
                    <option value="" selected>{{$store.state.option['conta_pessoal_reserved-DropOffStation-' + lang]}}</option>
                    <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
                  </select>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                  <date-picker v-model="form.CreationDate" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :placeholder="$store.state.option['conta_pessoal_reserved-CreationDate-' + lang]"></date-picker>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                  <date-picker v-model="form.DropOffDate" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :placeholder="$store.state.option['conta_pessoal_reserved-DropOffDate-' + lang]"></date-picker>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-b-10">
                <button class="btn btn-primary btn-xs btn-block float-right" @click="filtrarReservas()"><i class="glyphicon glyphicon-search margin-right-5"></i>{{$store.state.option['search_botao-' + lang]}}</button>
              </div>
        </div>
      </div>
    </div>

    <div class="table-responsive table-borderless" style="margin-top:20px;">
      <table class="table table-hover dataTable width-full table-striped table-condensed">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>{{$store.state.option['conta_pessoal_reserved-Reservation-' + lang]}}</th>
            <th>{{$store.state.option['conta_pessoal_reserved-StatusDescription-' + lang]}}</th>
            <th>{{$store.state.option['conta_pessoal_reserved-PickupStation-' + lang]}}</th>
            <th>{{$store.state.option['conta_pessoal_reserved-PickupDate-' + lang]}}</th>
            <th>{{$store.state.option['conta_pessoal_reserved-DropOffStation-' + lang]}}</th>
            <th>{{$store.state.option['conta_pessoal_reserved-DropOffDate-' + lang]}}</th>
            <th>{{$store.state.option['conta_pessoal_reserved-CreationDate-' + lang]}}</th>
            <th>{{$store.state.option['conta_pessoal_reserved-ReservationPreviewValue-' + lang]}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dt, index) in resX" :key="index" :class="{ 'oculto': !(index >= resA && index < resB) }">
            <td class="text-center"><a v-if="(dt.inAnalysis > 0 || dt.inAnalysis == 'true') && $store.state.user.role == 'driver'" :href="'/paypal/create-payment/' + dt.Reservation"><img alt="paypal" src="/img/paypal.png" style="max-width:35px" /></a></td>
            <td class="text-center"><a v-if="(dt.paid > 0 || $store.state.user.role == 'client') && dt.token" :href="'/pdf/' + dt.Reservation + '/' + dt.token + '?language=' + lang" class="btn btn-default btn-pure"><i class="fas fa-download"></i></a></td>
            <td class="text-right"><span v-if="!((dt.inAnalysis > 0 || dt.inAnalysis == 'true') && $store.state.user.role == 'driver')">{{ dt.Reservation }}</span></td>
            <td :class="dt.StatusDescription"><span v-if="(dt.inAnalysis > 0 || dt.inAnalysis == 'true') && $store.state.user.role == 'driver'">{{ $store.state.option['estado-waitingpayment-' + lang] }}</span><span v-else-if="dt.StatusCode === '0'">{{ $store.state.option['estado-waiting_confirmation-' + lang] }}</span><span v-else-if="dt.StatusCode === '3'">{{ $store.state.option['estado-not_confirmed-' + lang] }}</span><span v-else-if="dt.StatusCode === '6'">{{ $store.state.option['estado-turn_down-' + lang] }}</span><span v-else-if="dt.StatusCode === '5'">{{ $store.state.option['estado-under_analysis-' + lang] }}</span>
            <span v-else>{{ $store.state.option['estado-' + dt.StatusDescription + '-' + lang] }}</span></td>
            <td>{{ dt.PickupStation }}</td>
            <td>{{ dt.PickupDate.split(' ')[0] }}</td>
            <td>{{ dt.DropOffStation }}</td>
            <td>{{ dt.DropOffDate.split(' ')[0] }}</td>
            <td>{{ dt.CreationDate.split(' ')[0] }}</td>
            <td class="text-right">{{$store.state.option.moeda}} {{ dt.ReservationPreviewValue }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <nav v-if="totalPag > 1">
      <ul class="pagination float-right">
        <li style="padding: 0px 5px;border: solid 1px #ccc;" v-if="pag > 3"><a href="javascript:void(0)" @click="reservationPag(1)">1</a></li>
        <li style="padding: 0px 5px;border: solid 1px #ccc;" class="disabled" v-if="pag > 4"><a>...</a></li>

        <li style="padding: 0px 5px;border: solid 1px #ccc;" v-if="(pag - 2) > 0"><a href="javascript:void(0)" @click="reservationPag(pag-2)">{{pag - 2}}</a></li>
        <li style="padding: 0px 5px;border: solid 1px #ccc;" v-if="(pag - 1) > 0"><a href="javascript:void(0)" @click="reservationPag(pag-1)">{{pag - 1}}</a></li>

        <li style="padding: 0px 5px;border: solid 1px #ccc;" class="active"><a>{{pag}}</a></li>

        <li style="padding: 0px 5px;border: solid 1px #ccc;" v-if="pag < totalPag"><a href="javascript:void(0)" @click="reservationPag(pag+1)">{{pag + 1}}</a></li>
        <li style="padding: 0px 5px;border: solid 1px #ccc;" v-if="(pag + 1) < totalPag"><a href="javascript:void(0)" @click="reservationPag(pag+2)">{{pag + 2}}</a></li>

        <li style="padding: 0px 5px;border: solid 1px #ccc;" class="disabled" v-if="pag < (totalPag - 3)"><a>...</a></li>
        <li style="padding: 0px 5px;border: solid 1px #ccc;" v-if="pag < (totalPag - 2)"><a href="javascript:void(0)" @click="reservationPag(totalPag)">{{totalPag}}</a></li>
      </ul>

      <!--<ul class="pagination">
        <li :class="{'page-item': 1, 'oculto': dt == 0}" :style="dt == pag ? '' : 'background:#fff !important;'" v-for="dt in totalPag" :key="dt"><a @click="reservationPag(dt)" :class="{'page-link': 1, 'active': dt == pag}" :style="dt == pag ? 'color: #fff !important;' : ''" href="#">{{ dt }}</a></li>
      </ul>-->
    </nav>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'adminClient',
  data () {
    return {
      lang: '',
      res: [],
      pag: 1,
      totalPag: 1,
      resA: 0,
      resB: 1,
      resX: [],
      form: {
        Reservation: '',
        StatusDescription: '',
        PickupStation: '',
        PickupDate: '',
        DropOffStation: '',
        DropOffDate: '',
        CreationDate: ''
      },
      statusArray: {
        'Waiting confirmation': 0, // (To be confirmed in RW)
        Archived: 1,
        Confirmed: 1,
        Processed: 1,
        NoShow: 1,
        'Cancelled by the customer': 2,
        'Not confirmed': 3,
        'In analysis': 5, // In analysis - 5 (Under analysis in RW)
        'Turn-down': 6 // does not have a status description - WS bug
      },
      langData: {},
      estacoes: []
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.stations1 && this.$store.state.user1) {
        if (this.$store.state.user.role === 'admin') {
          this.$router.push('/admin', () => {})
          return
        }
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['conta_pessoal_driver-titulo-' + this.lang])
        let d = new Date()
        d.setMonth(d.getMonth() - 6)
        let d1 = new Date()
        d1.setMonth(d1.getMonth() + 7)
        this.axios.get('/reservations', { pickupDateFrom: d.getFullYear() + '-' + (d.getMonth() < 10 ? '0' : '') + d.getMonth() + '-01', pickupDateTo: d1.getFullYear() + '-' + (d1.getMonth() < 10 ? '0' : '') + d1.getMonth() + '-01' }).then((res) => {
          this.res = res.data
          this.pag = 1
          this.reservationPag(1)
          this.SET_LOAD()
        }, (er) => {
          this.SET_LOAD()
          // this.SET_AVISO(er.response.data.error)
        })
        this.langData = {
          days: [this.$store.state.option['sun-' + this.lang], this.$store.state.option['mon-' + this.lang], this.$store.state.option['tue-' + this.lang], this.$store.state.option['wed-' + this.lang], this.$store.state.option['thu-' + this.lang], this.$store.state.option['fri-' + this.lang], this.$store.state.option['sat-' + this.lang]],
          months: [this.$store.state.option['jan-' + this.lang], this.$store.state.option['fev-' + this.lang], this.$store.state.option['mar-' + this.lang], this.$store.state.option['apr-' + this.lang], this.$store.state.option['may-' + this.lang], this.$store.state.option['jun-' + this.lang], this.$store.state.option['jul-' + this.lang], this.$store.state.option['aug-' + this.lang], this.$store.state.option['sep-' + this.lang], this.$store.state.option['out-' + this.lang], this.$store.state.option['nov-' + this.lang], this.$store.state.option['levantamento_dec-' + this.lang]]
        }
        this.estacoes = this.$store.state.stations
      } else {
        this._.delay(this.init, 100)
      }
    },
    reservationPag (pag) {
      this.pag = pag
      this.resA = this.pag * 30 - 30
      this.resB = this.pag * 30
      let i = 0
      let contador = 0
      this.resX = []
      let l = new Date(this.form.PickupDate)
      let d = new Date(this.form.DropOffDate)
      let r = new Date(this.form.CreationDate)
      l.setHours(0, 0, 1)
      d.setHours(0, 0, 1)
      r.setHours(0, 0, 1)
      l = l.getTime()
      r = r.getTime()
      d = d.getTime()
      let l1 = ''
      let d1 = ''
      let r1 = ''
      while (this.res[i]) {
        l1 = new Date(this.res[i].PickupDate)
        d1 = new Date(this.res[i].DropOffDate)
        r1 = new Date(this.res[i].CreationDate)
        l1.setHours(0, 0, 1)
        d1.setHours(0, 0, 1)
        r1.setHours(0, 0, 1)
        l1 = l1.getTime()
        r1 = r1.getTime()
        d1 = d1.getTime()
        if ((!this.form.Reservation || this.form.Reservation.toString() === this.res[i].Reservation.toString()) && (!this.form.StatusDescription || this.statusArray[this.form.StatusDescription] === Number(this.res[i].StatusCode)) && (!this.form.PickupStation || this.form.PickupStation.toString() === this.res[i].PickupStationID.toString()) && (!this.form.DropOffStation || this.form.DropOffStation.toString() === this.res[i].DropOffStationID.toString()) && (!this.form.PickupDate || (l <= l1 && l > 0)) && (!this.form.DropOffDate || (d <= d1 && d > 0)) && (!this.form.CreationDate || (r <= r1 && r > 0))) {
          if (Number(this.res[i].StatusCode) === 1 && this.form.StatusDescription) {
            if (this.res[i].StatusDescription === this.form.StatusDescription) {
              this.resX.push(this.res[i])
              ++contador
            }
          } else {
            this.resX.push(this.res[i])
            ++contador
          }
        }
        ++i
      }
      this.totalPag = Math.ceil(contador / 30)
    },
    filtrarReservas () {
      this.reservationPag(1)
    }
  }
}
</script>
